import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";

export const SmartAlbumsCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings/smart-albums").then((r) => setS(r.data)); }, []);
  const toggle = async (enabled) => setS((await api.post("/settings/smart-albums", { enabled })).data);
  const restore = async () => {
    const { data } = await api.post("/settings/smart-albums/restore");
    setS(data);
    toast.success(`Restored ${data.restored} smart album(s)`);
  };
  return (
    <section className="settings-card mt-6" data-testid="settings-smart-albums">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="text-base font-semibold text-neutral-900">Auto-create smart albums</h2>
          <p className="text-sm text-neutral-500">Groups photos into albums like “Halloween 2022” or “Eiffel Tower” once 3 or more match.</p>
        </div>
        <Switch checked={Boolean(s?.enabled)} onCheckedChange={toggle} disabled={!s} data-testid="settings-smart-albums-toggle" />
      </div>
      <button className="btn-outline mt-5" onClick={restore} disabled={!s?.hidden_count} data-testid="settings-restore-smart-albums-button">
        Restore hidden smart albums{s?.hidden_count ? ` (${s.hidden_count})` : ""}
      </button>
    </section>
  );
};
